import axios from "axios";
import {
  addFailureNotification,
  addSuccessNotification,
  getServiceErrorMessage,
} from "../shell/notification/notifications";

const API = window.location.origin + "/api/";

export function Get(dispatch, method) {
  return axios
    .get(API + method)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);

      addFailureNotification(dispatch, error.message);

      return error;
    });
}

export function Post(dispatch, method, successMessage, data, methodUrl) {
  return axios
    .post(API + method, data, {
      params: {
        methodUrl: methodUrl,
      },
    })
    .then(function (response) {
      if (successMessage) {
        addSuccessNotification(dispatch, successMessage);
      }

      return response;
    })
    .catch(function (error) {
      console.log(error);

      addFailureNotification(dispatch, getServiceErrorMessage(error));

      return error;
    });
}

// Shared shape check for the responses returned by Post/Get/Delete above -
// axios resolves with a response on success and Post/Get/Delete's .catch
// handlers resolve with the caught error rather than rejecting, so callers
// can't just await and try/catch; they need to check the settled value.
export function isFailedResponse(response) {
  return !response || (response.status && response.status >= 400);
}
